/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Claim_Error_ContentInputs */

const en_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task not completed yet.`)
};

const ar_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُكتمل المهمة بعد.`)
};

const de_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabe noch nicht abgeschlossen.`)
};

const es_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarea aún no completada.`)
};

const fr_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche pas encore terminée`)
};

const it_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività non ancora completata.`)
};

const ja_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タスクはまだ完了していません。`)
};

const ko_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 미션을 완료하지 않았어요.`)
};

const pt_br_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa ainda não concluída.`)
};

const ru_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задача еще не выполнена.`)
};

const th_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`งานยังไม่เสร็จสิ้น`)
};

const tr_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görev henüz tamamlanmadı.`)
};

const zh_cn_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此任务尚未完成`)
};

const zh_tw_dialog_claim_error_content = /** @type {(inputs: Dialog_Claim_Error_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此任務尚未完成`)
};

/**
* | output |
* | --- |
* | "Task not completed yet." |
*
* @param {Dialog_Claim_Error_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_claim_error_content = /** @type {((inputs?: Dialog_Claim_Error_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Claim_Error_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_claim_error_content(inputs)
	if (locale === "ar") return ar_dialog_claim_error_content(inputs)
	if (locale === "de") return de_dialog_claim_error_content(inputs)
	if (locale === "es") return es_dialog_claim_error_content(inputs)
	if (locale === "fr") return fr_dialog_claim_error_content(inputs)
	if (locale === "it") return it_dialog_claim_error_content(inputs)
	if (locale === "ja") return ja_dialog_claim_error_content(inputs)
	if (locale === "ko") return ko_dialog_claim_error_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_claim_error_content(inputs)
	if (locale === "ru") return ru_dialog_claim_error_content(inputs)
	if (locale === "th") return th_dialog_claim_error_content(inputs)
	if (locale === "tr") return tr_dialog_claim_error_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_claim_error_content(inputs)
	return zh_tw_dialog_claim_error_content(inputs)
});